// Máscara de moeda BR — sempre trabalha com centavos internamente.
// - `toCents(raw)`: converte string livre → centavos (int).
// - `formatBRL(cents)`: 1234500 → "R$ 12.345,00".
// - `parseBRL(str)`: "R$ 12.345,00" → 12345 (número em reais).
export function toCents(raw) {
  const digits = String(raw ?? "").replace(/\D+/g, "");
  return digits ? parseInt(digits, 10) : 0;
}

export function formatBRL(cents) {
  const n = (Number(cents) || 0) / 100;
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function parseBRL(str) {
  return toCents(str) / 100;
}
